import React, { useEffect } from 'react';
import Header from './components/Header/Header';
import RoutedBody from './components/Body/RoutedBody';
import ScreenRouter from './components/Body/ScreenRouter';
import ProductStatusScreen from './components/Body/ProductStatusScreen';
import Footer from './components/Footer/Footer';
import PopupMessage from './components/Extra/PopupMessage';
import Feedbacks from './Management/Feedbacks';
import './assets/css/style.css';
import './assets/css/App.css';
import { AppProvider, useAppContext } from './Store/Store';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';

function Main() {
  const { globalNotification, setGlobalNotification } = useAppContext();

  return (
    <div className="app-root">
      {globalNotification && globalNotification[0] && (
        <PopupMessage
          message={globalNotification[0]}
          type={globalNotification[1]}
          timeout={3000}
          onClose={() => setGlobalNotification(['', 'success'])}
        />
      )}
      <Header />
      <div
        style={{
          flex: '1 1 auto',
          minHeight: 0,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <RoutedBody />
      </div>
      <Footer />
    </div>
  );
}

function ProductPage() {
  const { globalNotification, setGlobalNotification, fetchData, appState } =
    useAppContext();

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (appState === 'loading') {
    return (
      <div className="app-root">
        <Header />
        <div
          style={{
            flex: '1 1 auto',
            minHeight: 0,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          Loading...
        </div>
        <Footer />
      </div>
    );
  }

  // Product not found / deactivated (404) or other fetch failure: show a clear
  // message instead of letting ScreenRouter hang on an endless "Loading...".
  if (
    appState === 'not-found' ||
    appState === 'error' ||
    appState === 'no-token'
  ) {
    return (
      <div className="app-root">
        <Header />
        <div
          style={{
            flex: '1 1 auto',
            minHeight: 0,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <ProductStatusScreen state={appState} />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="app-root">
      {globalNotification && globalNotification[0] && (
        <PopupMessage
          message={globalNotification[0]}
          type={globalNotification[1]}
          timeout={3000}
          onClose={() => setGlobalNotification(['', 'success'])}
        />
      )}
      <Header />
      <div
        style={{
          flex: '1 1 auto',
          minHeight: 0,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <ScreenRouter />
      </div>
      <Footer />
    </div>
  );
}

function EmployeePage() {
  return (
    <div className="app-root">
      <Feedbacks />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          {/* Main route - redirects to first screen */}
          <Route path="/" element={<Main />} />

          {/* Screen routes */}
          <Route path="/registration" element={<ProductPage />} />
          <Route path="/feedback" element={<ProductPage />} />
          <Route path="/feedback-hold" element={<ProductPage />} />
          <Route path="/stars" element={<ProductPage />} />
          <Route path="/animation" element={<ProductPage />} />
          <Route path="/digital-content-pdf" element={<ProductPage />} />
          <Route path="/customer-id" element={<ProductPage />} />
          <Route path="/codescanner" element={<ProductPage />} />
          <Route path="/codescannerpistol" element={<ProductPage />} />
          <Route path="/registrationscanner" element={<ProductPage />} />
          <Route path="/photo-feedback" element={<ProductPage />} />
          <Route path="/consent" element={<ProductPage />} />
          <Route path="/device-data" element={<ProductPage />} />
          <Route path="/device-data-consumer" element={<ProductPage />} />
          <Route path="/links" element={<ProductPage />} />

          {/* Geo screen routes */}
          <Route path="/geo-register-screen" element={<ProductPage />} />
          <Route path="/geo-position-screen" element={<ProductPage />} />
          <Route path="/geo-verify-screen" element={<ProductPage />} />
          <Route path="/geo-processing" element={<ProductPage />} />

          {/* Employee page */}
          <Route path="/employee" element={<EmployeePage />} />

          {/* Fallback for unknown routes - redirect to main */}
          <Route path="*" element={<Main />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}
